import React, { useEffect, useRef, useState } from "react";
import { CELLS, CELL, fmt12, toHM } from "./scheduleUtils";

// One column of 30-min cells (07:00–22:00 IST). Tap toggles; drag paints a continuous
// range with the *first* cell's inverse value so no cell flips twice in one gesture.
export function DayColumn({ dayKey, label, cells, onChange, readOnly = false, showTimes = false }) {
  const drag = useRef(null); // { value, touched:Set }
  const [, force] = useState(0);

  const apply = (t, value) => {
    const next = new Set(cells);
    if (value) next.add(t); else next.delete(t);
    onChange(next);
  };
  const start = (t) => {
    if (readOnly) return;
    const value = !cells.has(t);
    drag.current = { value, touched: new Set([t]) };
    apply(t, value);
    force((n) => n + 1);
  };
  const move = (t) => {
    const d = drag.current;
    if (!d || d.touched.has(t)) return;
    d.touched.add(t);
    apply(t, d.value);
  };
  useEffect(() => {
    const end = () => { drag.current = null; };
    window.addEventListener("pointerup", end);
    window.addEventListener("pointercancel", end);
    return () => { window.removeEventListener("pointerup", end); window.removeEventListener("pointercancel", end); };
  }, []);

  return (
    <div className="flex flex-col gap-[3px] select-none" data-testid={`day-col-${dayKey}`}>
      {label && <p className="text-[11px] font-bold text-slate-600 text-center mb-1">{label}</p>}
      {CELLS.map((t) => {
        const on = cells.has(t);
        const hour = t % 60 === 0;
        return (
          <button
            key={t}
            type="button"
            data-testid={`cell-${dayKey}-${toHM(t)}`}
            data-on={on ? "1" : "0"}
            aria-label={`${label || dayKey} ${toHM(t)}–${toHM(t + CELL)} ${on ? "available" : "unavailable"}`}
            onPointerDown={(e) => { e.preventDefault(); start(t); }}
            onPointerEnter={() => move(t)}
            disabled={readOnly}
            className={`h-[18px] w-full rounded-[4px] border transition-colors touch-none ${on ? "bg-emerald-500 border-emerald-600" : "bg-white border-slate-200 hover:border-slate-400"} ${hour ? "" : "border-dashed"} disabled:cursor-default`}
          >
            {showTimes && hour && <span className="sr-only">{fmt12(toHM(t))}</span>}
          </button>
        );
      })}
    </div>
  );
}

export function TimeAxis() {
  return (
    <div className="flex flex-col gap-[3px] pr-1 w-12 shrink-0" aria-hidden>
      <p className="text-[11px] mb-1 h-[16px]" />
      {CELLS.map((t) => (
        <div key={t} className="h-[18px] text-[10px] text-slate-400 leading-[18px] text-right pr-1 whitespace-nowrap">
          {t % 60 === 0 ? fmt12(toHM(t)) : ""}
        </div>
      ))}
    </div>
  );
}
